var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReOpenTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "17px",
    height: "15.5px",
    viewBox: "0 0 17 15.5",
    style: {
      enableBackground: "new 0 0 17 15.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.4,5c-0.2-0.2-0.5-0.2-0.7,0l-2,2l-2-2C5.5,4.7,5.1,4.7,4.9,5c-0.2,0.2-0.2,0.5,0,0.7l2,1.9l-2,1.9 c-0.2,0.2-0.2,0.5,0,0.7c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.3,0,0.4-0.1l2-2l2,2c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3-0.1,0.4-0.2 c0.2-0.2,0.2-0.5,0-0.7l-2-1.9l2-1.9C10.6,5.5,10.6,5.2,10.4,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9,9.1l-1.4-1.8c-0.2-0.2-0.5-0.3-0.7-0.1l-2,1.4c-0.2,0.2-0.3,0.5-0.1,0.7c0.2,0.2,0.5,0.3,0.7,0.1 l1.1-0.7c-0.2,1.4-0.9,2.7-1.9,3.8c-1.3,1.3-3,2-4.7,2C4,14.5,1,11.5,1,7.7C1,6,1.7,4.3,3,3c1.3-1.3,3-2,4.7-2 c1.7,0,3.2,0.6,4.5,1.7c0.2,0.2,0.5,0.2,0.7,0c0.2-0.2,0.2-0.5,0-0.7c-1.4-1.3-3.3-2-5.2-2c-2.1,0-4,0.8-5.5,2.3 C0.8,3.7,0,5.7,0,7.7c0,4.3,3.5,7.8,7.7,7.8c2.1,0,4-0.8,5.5-2.3c1.2-1.2,1.9-2.7,2.2-4.3l0.7,0.9c0.1,0.1,0.3,0.2,0.4,0.2 c0.1,0,0.2,0,0.3-0.1C17,9.7,17.1,9.4,16.9,9.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReOpenTask);
export default __webpack_public_path__ + "static/media/re-open-task.27e2005f519eefdccf9807e1f96e2e5b.svg";
export { ForwardRef as ReactComponent };